export default __webpack_public_path__ + "static/media/LogoMGI.ee1d1301.png";